import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { ProgressBar } from 'react-bootstrap';
import { AppModal } from '@/layout/AppComponents';
import PreventNavigation from './PreventNavigation';
import { axiosPath } from '../../../routing/helpers/router';
import useIsMounted from '../hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function LoopModal({
  route,
  value,
  title = '',
  size = 'md',
  confirmBtnText = 'Finalizar',
  onInit = () => { },
  onFinish = () => { },
  onConfirmFinish = () => { },
  onError = () => { },
  closeOnFinish = false,
}) {
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [showLoopModal, setShowLoopModal] = useState();
  const [loopInfo, setLoopInfo] = useState();
  const global = useSelector((state) => state.global);

  const handleLoop = useCallback(async () => {
    axios
      .post(axiosPath(route), {
        tempBatchLoopID: loopInfo?.tempBatchLoopID,
        locale: global.urlData.lang,
        ...value,
      })
      .then(({ data }) => {
        if (isMounted.current) {
          if (!loopInfo?.tempBatchLoopID) setShowLoopModal(true);
          setLoopInfo(data);
        }
      })
      .catch((e) => {
        dispatch(errorHandler(e));
        onError();
      });
  }, [loopInfo, value]);

  useEffect(() => {
    if (value) {
      onInit();
      handleLoop();
    }
  }, [value]);

  useEffect(() => {
    if (loopInfo && !loopInfo?.isFinished) {
      handleLoop();
    } else if (loopInfo && loopInfo.isFinished) {
      onFinish(loopInfo?.results);
      if (closeOnFinish) {
        setShowLoopModal(false);
        setLoopInfo(undefined);
      }
    }
  }, [loopInfo]);

  return (
    <AppModal
      show={showLoopModal}
      title={title}
      size={size}
      isCloseButton={false}
      isConfirmBtn={loopInfo?.isFinished}
      confirmBtnText={confirmBtnText}
      onConfirm={() => {
        if (loopInfo?.isFinished) {
          setLoopInfo(undefined);
          setShowLoopModal(false);
          onConfirmFinish();
        }
      }}
    >
      <>
        {!loopInfo?.isFinished && <PreventNavigation />}
        <h4>{loopInfo?.modalInfo?.message}</h4>
        <ProgressBar
          animated
          now={loopInfo?.modalInfo?.percent}
          label={`${parseInt(loopInfo?.modalInfo?.percent, 10)}%`}
        />
      </>
    </AppModal>
  );
}
